export const TRENDS_EVENT_KEY = '/analytics/trends';
export const CONCURRENCY_EVENT_KEY = '/analytics/trends/concurrency';
